import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/specified_special_permanent_resident_certificate.png")